export class FirmatarioVO {
  cf: string;

  cmu: string;

  descrizione: string;
}
